import { render } from "./BehaviourGroupSelect.vue?vue&type=template&id=8f2c4306"
import script from "./BehaviourGroupSelect.vue?vue&type=script&lang=js"
export * from "./BehaviourGroupSelect.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__